import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
//Mui components
import {
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    List,
    ListItem,
    ListItemText,
    TextField,
    DialogTitle
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import { TransitionGroup } from 'react-transition-group';
//Styles
import useStyles from 'components/dialogs/site/DialogManageSite.style';
import DialogConfirm from '../commons/DialogConfirm';
//Locales
import translate from 'locales/i18n';

const DialogAdboxConfiguration = ({
    close,
    open,
    senderMails,
    setSendersMails
}) => {
    const classes = useStyles();
    const [currentEmail, setCurrentEmail] = useState('');
    const [mailList, setMailList] = useState([]);

    const [openDialogConfirm, setOpenDialogConfirm] = useState(false);

    useEffect(() => {
        if (open) {
            senderMails ? setMailList(senderMails) : setMailList([]);
            setCurrentEmail('');
        }
    }, [open]);

    const handleAddMail = (emailString) => {
        if (!verifyMail(emailString)) return;
        setMailList(prev => [emailString, ...prev]);
        setCurrentEmail('');
    };

    const handleRemoveMail = (emailString) => setMailList(prev => [...prev.filter(m => m !== emailString)]);

    const verifyMail = (newMail) => {
        if (!newMail || newMail === '') return false;
        if (mailList.includes(newMail)) return false;
        return true;
    };

    const renderDialogConfirm = () => <DialogConfirm
        text={translate.i18n('CONFIRM_SITE_ADBOX_CONFIG')}
        callback={() => handleAddMail(currentEmail)}
        open={openDialogConfirm}
        close={() => {
            setCurrentEmail('');
            setOpenDialogConfirm(false);
        }}
    />;

    const renderItem = ({ email }) => <ListItem
        secondaryAction={
            <IconButton
                edge='end'
                aria-label='delete'
                title='Delete'
                onClick={() => handleRemoveMail(email)}
            >
                <DeleteIcon />
            </IconButton>
        }
    >
        <ListItemText primary={email} />
    </ListItem>;

    return <Dialog
        open={open}
        onClose={close}
        classes={{
            paper: classes.dialogPaper
        }}>
        <DialogTitle>
            {translate.i18n('SITE_CONFIG_ADBOX_TITLE')}
        </DialogTitle>
        <DialogContent>
            <div className={classes.mailAdd}>
                <TextField
                    size='small'
                    label='Email à ajouter'
                    className={classes.mailAddText}
                    type='email'
                    value={currentEmail}
                    onKeyUp={(event) => {
                        if (event.key === 'Enter')
                            handleAddMail(currentEmail);
                    }}
                    onChange={event => setCurrentEmail(event.target.value)}
                />
                <IconButton onClick={() => handleAddMail(currentEmail)}>
                    <AddIcon />
                </IconButton>
            </div>
            <List>
                <TransitionGroup>
                    {mailList.map((email) => <Collapse key={email}>
                        {renderItem({ email })}
                    </Collapse>
                    )}
                </TransitionGroup>
            </List>
        </DialogContent>
        <DialogActions>
            <IconButton
                color='primary'
                onClick={() => {
                    if (currentEmail) {
                        setOpenDialogConfirm(true);
                    } else {
                        setSendersMails('senderMails', mailList);
                        close();
                    }
                }}>
                <DoneIcon />
            </IconButton>
        </DialogActions>
        {renderDialogConfirm()}
    </Dialog>;
};

DialogAdboxConfiguration.propTypes = {
    close: PropTypes.func,
    open: PropTypes.bool,
    senderMails: PropTypes.array,
    setSendersMails: PropTypes.func
};

export default DialogAdboxConfiguration;
